const storedAuth = localStorage.getItem("asg_insurance_admin")
const parsedAuth = storedAuth ? JSON.parse(storedAuth) : {}

const initialState = {
    auth: parsedAuth,
    isAuthenticated: Boolean(parsedAuth?.token),
    loading: false,
    clearingSession: false,
    errors: {},
}

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_PENDING":
            return { ...state, loading: true, errors: {} }
        case "LOGIN_FULFILLED":
            return { ...state, loading: false, auth: action.payload, isAuthenticated: true, errors: {} }
        case "LOGIN_FAILED":
            return { ...state, loading: false, errors: action.payload }
        case "CLEAR_SESSION_PENDING":
            return { ...state, clearingSession: true, errors: {} }
        case "CLEAR_SESSION_FULFILLED":
            return { ...state, clearingSession: false }
        case "CLEAR_SESSION_FAILED":
            return { ...state, clearingSession: false, errors: action.payload }
        case "LOGOUT_USER_PENDING":
            return { ...state, loading: true, errors: {} }
        case "LOGOUT_USER_FULFILLED":
            return { ...state, loading: false, auth: {}, isAuthenticated: false, errors: {} }
        case "LOGOUT_USER_FAILED":
            return { ...state, loading: false, auth: {}, isAuthenticated: false, errors: action.payload }
        default:
            return state
    }
}

export default AuthReducer
